var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src)?_c('img',{attrs:{"src":_vm.processedSrc,"width":_vm.width,"height":_vm.height},on:{"error":_vm.handleError}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }